export default "__VITE_ASSET__DSNXzQQt__"